import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/admin/sftp/")({
    beforeLoad: () => {
        throw redirect({ to: "/developer/sftp/diaries", replace: true });
    },
});
